import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';

const { SkeletonPart, FlexPane } = MojitoPresentation.Components;

export default function PriceBoostCouponSkeleton(props) {
    const {
        mojitoTools: { config },
    } = props;
    return (
        <FlexPane config={config.eventsContainer} class={'ta-PriceBoostCouponSkeleton'}>
            {range(config.numberOfBoostedMarkets).map(key => (
                <BoostedMarketSkeleton key={key} config={config} />
            ))}
        </FlexPane>
    );
}

const BoostedMarketSkeleton = ({ config }) => {
    return (
        <FlexPane config={config.container}>
            <FlexPane config={config.eventHeaderContainer}>
                <SkeletonPart config={config.eventNameLabel} />
                <SkeletonPart config={config.startTime} />
            </FlexPane>
            <FlexPane config={config.marketGroupContainer}>
                <PriceBoostMarket config={config} />
                <PriceBoostMarket config={config} />
            </FlexPane>
        </FlexPane>
    );
};

const PriceBoostMarket = ({ config }) => (
    <FlexPane config={config.priceBoostMarketContainer}>
        <FlexPane config={config.eventDataContainer}>
            <SkeletonPart config={config.selectionLabel} />
            <SkeletonPart config={config.marketLabel} />
        </FlexPane>
        <SkeletonPart config={config.selection} />
    </FlexPane>
);
